import { ApiEndpoints } from '@shared/api/api-endpoints';
import { CreateDisconnectionRequestPayload, DisconnectResponse } from'./types';
import { cxApiClient } from '@shared/api/clients/apiClientFactory';

export const disconnectApis = {
     createDisconnectionRequest: async (
    payload: CreateDisconnectionRequestPayload
  ): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", "connection-status-request");
    const response = await cxApiClient.post(url, payload);
    return response.data;
  },
}